import {useSelector} from 'react-redux';
import {useAbortableLoad} from "../../Hooks";
import "./style.css";
import DocsSecondRight from "../../old_components/DocsMain/DocsSecond/DocsSecondRight.jsx";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";
import mapStateToProps from './mapStateToProps'
import {getCriteria} from '../../shared/helpers/getCriteria.js';

const Dashboard = () => {

    const {
        selectedGeoObjArray = [],
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate
    } = useSelector(mapStateToProps)

    const criteria = getCriteria(
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
    )

    const geoObjDashboard = useAbortableLoad(
        'getGeoObjDashboard',
        'geoObjDashboard',
        {objId: selectedGeoObjArray[0], criteria},
        selectedGeoObjArray?.length === 1,
        [selectedGeoObjArray, dateRangeCriteria, rangeStartDate, rangeEndDate],
        'setGeoObjDashboard'
    )

    return (
        <ContentContainer
            content={(
                <DocsSecondRight geoObjReport={geoObjDashboard}/>
            )}
        />

    )
}

export default Dashboard
